import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

export const StyledButtonWrap = styled.div`
    flex-shrink: 0;

    &:first-child {
        padding-right: 10px;
    }

    &:last-child {
        padding-left: 10px;
    }
`;

export const StyledModalHeader = styled.div`
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid ${colorsPalettes.carbon["100"]};
`;
